<div>
  <ng-container #container></ng-container>
</div>

<div #form>
  <div *ngIf="formContainer" class="card card-body">
    <div class="icon col-12 mb-md-6 mb-1">
      <div class="icon-container">
        <div class="icon-newsletter">
          <app-svg iconName="Newsletter" fill="white" dimension="7.5rem"></app-svg>
        </div>
        <div class="icon-percentage">
          <app-svg iconName="Percentage" fill="white" dimension="1.375rem"></app-svg>
        </div>
      </div>
    </div>
    <div class="header-text text-center col-12 mb-md-6 mb-1">
      <h2 class="mb-md-6 mb-1">{{ 'habaNewsletterProcess.subscription.title' | cxTranslate }}</h2>
      <h3>{{ 'habaNewsletterProcess.subscription.description' | cxTranslate }}</h3>
    </div>
    <form (ngSubmit)="submitForm()" [formGroup]="newsletterForm" class="row">
      <div class="col-12">
        <div class="form-row">
          <div class="col">
            <app-form-input>
              <app-form-label [attr.data-qa]="emailTextfieldQaId?.getLabelId()"
                >{{
                  'habaNewsletterProcess.subscription.email.label' | cxTranslate
                }}
                *</app-form-label
              >
              <input
                appFormInput
                formControlName="email"
                type="text"
                [attr.data-qa]="emailTextfieldQaId?.getInputId()"
              />
              <app-form-error>{{
                'habaNewsletterProcess.subscription.email.error' | cxTranslate
              }}</app-form-error>
            </app-form-input>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-row">
          <div class="col">
            <app-form-checkbox [flexStart]="true">
              <app-form-label [attr.data-qa]="termsCheckboxQaId?.getLabelId()">
                <small
                  class="consent-row"
                  [innerHTML]="
                    'habaNewsletterProcess.subscription.isAgreed.label'
                      | cxTranslate
                        : {
                            privacyUrl: getLocalizedUrl(privacyUrl),
                            termsUrl: getLocalizedUrl(termsUrl),
                            cancellationUrl: getLocalizedUrl(cancellationUrl),
                          }
                  "
                ></small>
              </app-form-label>
              <input
                appFormCheckbox
                formControlName="isAgreed"
                type="checkbox"
                [attr.data-qa]="termsCheckboxQaId?.getCheckboxId()"
              />
              <app-form-error>
                <small>{{
                  'habaNewsletterProcess.subscription.isAgreed.error' | cxTranslate
                }}</small>
              </app-form-error>
            </app-form-checkbox>
          </div>
        </div>
        <button
          [disabled]="disableSendButton || newsletterForm.invalid"
          class="btn btn-primary mt-9 d-flex w-100"
          type="submit"
          [attr.data-qa]="submitButtonQaId?.getButtonId()"
        >
          <span class="mr-5">{{ 'habaNewsletterProcess.subscription.submit' | cxTranslate }}</span>
          <app-svg dimension="1.8em" iconName="Newsletter"></app-svg>
        </button>
      </div>
    </form>
  </div>
</div>
